export default __webpack_public_path__ + "static/media/Hindi_cm_1.d308734c.mp3";